<template>
  <div class="p-4">
    <p v-if="loading" class="text-sm text-[#1c4848]/50">Loading…</p>
    <p v-else-if="error" role="alert" class="text-sm text-red-700">{{ error }}</p>
    <p v-else-if="!revisions.length" class="text-sm leading-relaxed text-[#1c4848]/50">Earlier versions appear here once you start writing. One is kept every ten minutes while you work.</p>
    <ul v-else class="space-y-2">
      <li v-for="(revision, i) in revisions" :key="revision.id" class="flex items-center justify-between gap-2 rounded-xl border border-[#1c4848]/10 bg-white p-3">
        <div class="min-w-0">
          <p class="text-xs font-bold text-[#1c4848]">{{ when(revision.created_at) }}</p>
          <p v-if="revision.author" class="truncate text-[11px] text-[#1c4848]/55">{{ revision.author }}</p>
        </div>
        <button v-if="confirming !== revision.id" type="button" class="min-h-9 shrink-0 rounded-lg px-2 text-xs font-bold text-[#1c4848]/70 hover:bg-[#1c4848]/5 disabled:opacity-40" :disabled="readOnly" @click="confirming = revision.id">Restore</button>
        <button v-else type="button" class="min-h-9 shrink-0 rounded-lg bg-[#1c4848] px-3 text-xs font-bold text-white" @click="$emit('restore', revision.id); confirming = null">Replace the page</button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { usePageContentsStore } from '@/store/page-contents/index.js';

const props = defineProps({
  pageId: { type: [String, Number], required: true },
  version: { type: Number, default: 0 },
  readOnly: { type: Boolean, default: false },
});
defineEmits(['restore']);

const store = usePageContentsStore();
const revisions = ref([]);
const loading = ref(true);
const error = ref('');
const confirming = ref(null);

async function load() {
  error.value = '';
  try {
    revisions.value = await store.fetchDocumentRevisions(props.pageId);
  } catch {
    error.value = 'The versions could not be loaded.';
  } finally {
    loading.value = false;
  }
}

function when(iso) {
  return new Date(iso).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

onMounted(load);
watch(() => [props.pageId, props.version], load);
</script>
